<template>
  <b-card v-if="templates !== null">
    <b-card-header class="p-0 mb-1">
      <div class="d-flex align-items-center card-title-responsive-60">
        <h4 class="card-title">
          {{ $t('settings.templates') }}
        </h4>
      </div>
      <b-button-group class="ml-1">
        <b-button
          v-if="item === null"
          id="btn-new-template"
          variant="outline-primary"
          class="btn-icon"
          @click="addNew()"
        >
          <feather-icon icon="FileIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-new-template"
            :title=" $t('settings.new-template')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          v-if="item !== null"
          id="btn-save-template"
          variant="outline-primary"
          class="btn-icon"
          :disabled="!somethingChanged || !isValidate"
          @click="submit()"
        >
          <feather-icon icon="SaveIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-save-template"
            :title=" $t('common.save')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          v-if="item !== null"
          id="btn-help-template"
          variant="outline-primary"
          class="btn-icon"
          @click="help()"
        >
          <feather-icon icon="HelpCircleIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-help-template"
            :title=" $t('settings.template-help')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          v-if="item !== null"
          id="btn-delete-template"
          variant="outline-primary"
          class="btn-icon"
          @click="deleete()"
        >
          <feather-icon icon="Trash2Icon" />
          <b-tooltip
            triggers="hover"
            target="btn-delete-template"
            :title=" $t('common.delete')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          v-if="item !== null"
          id="btn-cancel-template"
          variant="outline-primary"
          class="btn-icon"
          @click="close()"
        >
          <feather-icon icon="XIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-cancel-template"
            :title=" $t('common.close')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
      </b-button-group>
    </b-card-header>
    <b-card-body class="p-0">
      <b-table
        v-if="item === null"
        :items="templates"
        :fields="tableColumns"
        show-empty
        :empty-text=" $t('common.no-matching')"
        responsive
        striped
        bordered
        thead-class="d-none"
      >
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-right">
            <b-link
              class="text-nowrap ml-1"
              @click="edit(data.item)"
            >
              <feather-icon
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
              />
            </b-link>
          </div>
        </template>
        <template #cell(label)="data">
          <span>
            {{ data.item.label }}<span class="clearfix" /> <small>{{ categoryOptions.find(x=> x.value === data.item.category ).text }} - {{ formatDateHumanFriendly(data.item.lastUpdate) }}</small>
          </span>
        </template>

      </b-table>
      <b-form v-if="item !== null">
        <b-row>
          <b-col
            cols="12"
            lg="12"
          >
            <b-form-group
              :label="$t('settings.template-name')"
              label-for="template-name"
            >
              <b-form-input
                id="template-name"
                v-model="item.label"
                trim
              />
            </b-form-group>
          </b-col>
          <!-- Field: Custom Properties -->
          <b-col
            cols="12"
            lg="12"
          >
            <b-form-group
              :label="$t('settings.template-custom-props')"
              label-for="customProps"
            >
              <div class="form-label-group ">
                <b-form-textarea
                  id="customProps"
                  v-model="item.customProps"
                  rows="3"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- Field: Category -->
          <b-col
            cols="12"
            lg="12"
          >
            <b-form-group
              :label="$t('settings.template-category')"
              label-for="category"
              label-class="mb-1"
            >
              <b-form-radio-group
                id="category"
                v-model="item.category"
                :options="categoryOptions"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            lg="12"
          >
            <hr>
            <span v-if="itemAttachment === null">
              {{ $t('settings.no-file') }}
            </span>
            <div
              v-if="itemAttachment !== null"
              class="d-flex align-items-center"
            >
              <b-avatar
                variant="light-secondary"
                rounded
              >
                <feather-icon
                  :icon="`${resolveFileIcon(itemAttachment.filename)}Icon`"
                  size="18"
                />
              </b-avatar>
              <div class="ml-1">
                <b-link
                  class="font-weight-bold d-block text-nowrap"
                  @click="download(itemAttachment.fid)"
                >
                  {{ itemAttachment.filename }}
                </b-link>
                <small>{{ formatFileType(itemAttachment.filename) }} ({{ formatBytes(itemAttachment.size, 1) }}) - {{ formatDateHumanFriendly(itemAttachment.lastUpdate) }}</small>
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            lg="12"
          >
            <b-input-group class="mt-2">
              <b-form-file
                ref="uploader"
                size="sm"
                :placeholder="$t('attachments.placeholder')"
                :drop-placeholder="$t('attachments.drop-placeholder')"
                accept=".doc, .docx"
              />
              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="upload()"
                >
                  <feather-icon
                    icon="UploadIcon"
                    class="mr-50"
                  />
                  <span class="align-middle">{{ $t('attachments.upload') }}</span>
                </b-button>
              </b-input-group-append>
            </b-input-group></b-col>
        </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BFormFile, BInputGroupAppend, BInputGroup, BAvatar, BFormTextarea,
  BCard, BCardBody, BCardHeader, BTable, BLink, BButton, BButtonGroup, BTooltip, BForm, BFormInput, BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import i18n from '@/libs/i18n'
import {
  formatFileType, resolveFileIcon, formatBytes, formatDateHumanFriendly, download, clone, removeFromArray, swalDeleteOptions,
} from '@/views/layouts/layouts.utils'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BAvatar,
    BTable,
    BLink,
    BCardHeader,
    BButton,
    BButtonGroup,
    BTooltip,
    BForm,
    BFormInput,
    BFormGroup,
    BFormFile,
    BInputGroupAppend,
    BInputGroup,
    BFormRadioGroup,
    BFormTextarea,
  },

  props: {
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    templates: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      item: null,
      itemAttachment: null,
      original: null,
      somethingChanged: false,
      isValidate: false,
      categoryOptions: [
        { text: i18n.t('navigation.list-contributors'), value: 'contributors' },
        { text: i18n.t('navigation.list-sad'), value: 'sad' },
        { text: i18n.t('navigation.list-projects'), value: 'projects' },
      ],
      tableColumns: [{ key: 'label' }, { key: 'actions' }],
    }
  },
  async mounted() {
    this.$watch('refaid', () => { this.reset() })
    this.$watch('item', () => {
      if (this.item) {
        this.somethingChanged = true
        this.isValidate = (this.item.label && this.item.uuid)
      }
    }, { deep: true })
  },
  methods: {
    reset() {
      this.item = null
      this.itemAttachment = null
      this.original = null
    },
    addNew() {
      this.item = {
        label: i18n.t('settings.new-template'),
        category: 'contributors',
        uuid: null,
        lastUpdate: new Date(),

      }
      this.original = null
      this.itemAttachment = null
      this.somethingChanged = false
    },
    async edit(item) {
      this.item = item
      this.item.lastUpdate = new Date()
      this.original = clone(item)
      await this.reloadAttachment()
      this.somethingChanged = false
    },
    async help() {
      axios.get(`/api/docx/${this.item.category}`, { params: { aid: this.refaid }, responseType: 'blob' })
        .then(response => {
          download(response, `${this.item.label}.docx`)
        })
    },
    deleete() {
      this.$swal(swalDeleteOptions).then(result => {
        if (result.value === true) {
          if (this.original !== null) {
            removeFromArray(this.templates, this.item)
            this.submit()
          } else this.reset()
        }
      })
    },
    async reloadAttachment() {
      if (this.item && this.item.uuid) {
        axios.post('/api/storage', { aid: this.refaid, fids: [this.item.uuid] })
          .then(response => {
            const items = response.data
            if (items.length === 1) {
              // eslint-disable-next-line prefer-destructuring
              this.itemAttachment = items[0]
            }
          })
      } else this.itemAttachment = null
    },
    async upload() {
      const formData = new FormData()
      const file = this.$refs.uploader.files[0]
      if (file) {
        formData.append('upload', file, file.name)
        const response = await axios.put('/api/storage', formData, {
          params: { aid: this.refaid },
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.$refs.uploader.reset()
        // eslint-disable-next-line prefer-destructuring
        this.item.uuid = response.data[0]
        await this.reloadAttachment()
      }
    },
    async download(fid) {
      const response = await axios.get('/api/storage', {
        params: { aid: this.refaid, fid },
        responseType: 'blob',
      })
      download(response)
    },
    close() {
      if (this.original) {
        this.item.label = this.original.label
        this.item.uuid = this.original.uuid
      }
      this.original = null
      this.item = null
    },
    submit() {
      if (this.original === null) { // new item
        this.templates.push(this.item)
      }
      this.$emit('on-submit')
      this.reset()
    },
  },
  setup() {
    return {
      formatFileType,
      formatBytes,
      resolveFileIcon,
      formatDateHumanFriendly,
    }
  },
}
</script>
